import React from "react";

import { NotificationSnackbar } from "shared/ui";

import { AccountContext } from "features/Account/context";
import { useAccountState } from "features/Account/hooks/useAccountState";
import { PasswordCard } from "features/Account/components/PasswordCard";
import { ProfileCard } from "features/Account/components/ProfileCard";

import { Container, Placeholder } from "./styles";

// Без observer: состояние фичи не читает observable — стор нужен только для выхода из аккаунта.
export const Account = () => {
    const state = useAccountState();

    if (state.loading) {
        return <Placeholder>Загрузка аккаунта…</Placeholder>;
    }

    if (!state.account) {
        return <Placeholder>Не удалось загрузить данные аккаунта</Placeholder>;
    }

    return (
        <AccountContext.Provider value={state}>
            <Container>
                <ProfileCard />
                <PasswordCard />

                <NotificationSnackbar {...state.notify.snackbarProps} />
            </Container>
        </AccountContext.Provider>
    );
};
